var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZomato(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffdce1;}.cls-2{fill:#ca212f;}.cls-3{fill:#f4f5f5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zomato") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15,
    cy: 15,
    r: 12.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.26,16c0,.06.18,0,.21,0a35.41,35.41,0,0,1,4-.05,3.52,3.52,0,0,1,1.5.29,5.92,5.92,0,0,1,1.81,1.48A8.18,8.18,0,0,0,12.61,20a8.5,8.5,0,0,0,4.69.7A14.52,14.52,0,0,0,22.8,19a6.37,6.37,0,0,0,2.67-2.5,2.45,2.45,0,0,0,.15-2.36,5.89,5.89,0,0,0-2.33-2.51,14.06,14.06,0,0,0-7-2,8,8,0,0,0-5.38,1.86l-.19.15a5.32,5.32,0,0,0-.74.76,6.68,6.68,0,0,1-1.45,1.36,2.76,2.76,0,0,1-1.25.55,20.56,20.56,0,0,1-3.14.08c-.58,0-1.17,0-1.75-.08,0,0-.14,0-.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.43,11.52a14.55,14.55,0,0,0-2.8,0,6.58,6.58,0,0,0-2.16.69l-.12.07a.28.28,0,0,1-.41-.11.29.29,0,0,1,.16-.41,6.63,6.63,0,0,1,1.73-.57,10,10,0,0,1,3.54.12,5.44,5.44,0,0,0,.78.17c-.06.13-.16.07-.24.06h0C18.76,11.5,18.59,11.58,18.43,11.52Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZomato);
export default __webpack_public_path__ + "static/media/Zomato.ee2fa74b19ceb073400c55f6f63b29eb.svg";
export { ForwardRef as ReactComponent };